import { useEffect, useRef } from "react";
import { useNavigate, NavLink } from "react-router-dom";

import "./Navbar.css";

import Link from "../_components/link/Link";

import createAnimation from "../_utils/createAnimation";
import { BLACK_LOGO } from "../_media/assets";
import { BOOK_SESSION } from "../_utils/links";

const Navbar = () => {
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => createAnimation(ref), []);
  const active = ({ isActive }) => (isActive ? "active" : "");
  const goHome = () => navigate("/");
  return (
    <header>
      <nav className="Navbar" ref={ref}>
        <img className="Navbar-logo" src={BLACK_LOGO} alt="" onClick={goHome} />
        <section className="Navbar-links">
          <NavLink to="/" className={active} end>Home</NavLink>
          <NavLink to="about-me" className={active}>About Me</NavLink>
          <NavLink to="services" className={active}>Services</NavLink>
          <Link primary ariaLabel="Click to book a free session" link={BOOK_SESSION}>Book a free session</Link>
        </section>
      </nav>
    </header>
  );
};

export default Navbar;
